import { render, staticRenderFns } from "./MenuBarHighlightButton.vue?vue&type=template&id=5cef605b"
import script from "./MenuBarHighlightButton.vue?vue&type=script&lang=js"
export * from "./MenuBarHighlightButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports